import React from "react";

export default function MessageAlert({ message, handleClose }) {
    return (
        <>
            {message instanceof Array && message.length > 0 ? (
                <ul className="meet-message-pop-screen">
                    {message.map((value, key) => {
                        return (
                            <li key={`message_${key}`} onClick={() => $(".chat-btn").trigger("click")}>
                                <div class="messaage-pop-dt">
                                    <span class="messanger-img">
                                        <img
                                            src={value.profile && value.profile !== "" ? value.profile :
                                             "public/assets/images/Mask.png"}
                                            alt="a"
                                        />
                                    </span>
                                    <span class="messanger-name">
                                        <i
                                            class="fas fa-times"
                                            onClick={(e) => { e.stopPropagation(); handleClose(value) }}
                                        ></i>
                                        <h3>{value.from_name}</h3>
                                        <p>{value.message}</p>
                                    </span>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            ) : null}
        </>
    );
}
